<template>
  <div class="main">
    <!-- 蓝字发票开具 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('goInvoice')"><Back /></el-icon>
        <h2 class="bread">红字发票业务</h2>
      </div>
    </div>
    <div class="operate-main">
      <div class="operate-wrap">
        <div class="common-box">
          <h3 class="title">概括统计</h3>
          <div class="common-box-content">
            <div class="data-wrap">
              <div class="data-item">
                <p style="font-size: 14px; color: #333">本月回退授信额度（元）</p>
<!--                <p style="font-size: 24px; color: #333; line-height: 40px">{{ Number(statistics.htsxed ?? 0).toFixed(2) }}</p>-->
                <p style="font-size: 24px; color: #333; line-height: 40px">0</p>
                <p style="font-size: 16px; color: #666; margin-top: 20px">-</p>
              </div>
              <div class="data-item">
                <p style="font-size: 14px; color: #333">本月应转出进项额税（元）</p>
                <p style="font-size: 24px; color: #333; line-height: 40px">0.00</p>
                <p style="font-size: 16px; color: #666; margin-top: 20px">本月共收到红字发票金额：0.00</p>
              </div>
              <div class="data-item">
                <p style="font-size: 14px; color: #333">本月发出去的确认单（元）</p>
                <p style="font-size: 24px; color: #333; line-height: 40px">{{ statistics?.fcqrd }}</p>
                <p style="font-size: 16px; color: #666; margin-top: 20px">-</p>
              </div>

              <div v-if="currentQa.sonQueType == '39'" class="data-item">
                <p style="font-size: 14px; color: #333">本月收到的确认单（元）</p>
                <p style="font-size: 24px; color: #333; line-height: 40px">{{ qa39Info.allConfirmLength }}</p>
                <p style="font-size: 16px; color: #666; margin-top: 20px">当前待处理：{{ qa39Info.confirmTodo }}</p>
              </div>
              <div v-else class="data-item">
                <p style="font-size: 14px; color: #333">本月收到的确认单（元）</p>
                <p style="font-size: 24px; color: #333; line-height: 40px">{{ statistics?.sdqrd }}</p>
                <p style="font-size: 16px; color: #666; margin-top: 20px">当前待处理：{{ withDeal }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="common-box">
          <h3 class="title">常用功能</h3>
          <div class="common-box-content">
            <div class="tool-box">
              <ul>
                <li v-for="item in toolList" :key="item.key" class="hz-item" @click="operate(item)">
                  <img :src="item.url" alt="#" style="width: 40px; object-fit: contain" />
                  <div>
                    <p style="font-size: 14px; font-weight: 600; color: #333">{{ item.name }}</p>
                    <p style="font-size: 12px; color: #999; margin-top: 5px">{{ item.text }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="common-box">
          <h3 class="title">红字发票确认信息</h3>
          <div class="common-box-content">
            <div class="table_hd">
              <el-radio-group v-model="qrdType" @change="selectQrd">
                <el-radio-button label="我发出的确认单" value="fcqrd" />
                <el-radio-button label="发给我的确认单" value="fwqrd" />
                <el-radio-button label="我发出的信息表" value="fcxxb" />
              </el-radio-group>
            </div>
            <div class="table_wrap">
              <confirm-outer
                  v-if="qrdType == 'fwqrd' && currentQa.sonQueType == '39'"
              />
              <el-table
                  v-else
                  :data="qrdList" :border="true">
                <el-table-column label="购销身份">
                  <template #default="{ row }">
                    <span>{{ row.applyType.substring(0, 3) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="对方纳税人名称">
                  <template #default="{ row }">
                    <span>{{ row.buyer?.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="纳税人识别号">
                  <template #default="{ row }">
                    <span>{{ row.buyer?.taxRegistrationNo }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="对应蓝票数电票号码" prop="code" />
                <el-table-column label="红字通知单编号" prop="number" />
                <el-table-column label="发票金额" prop="totalAmount">
                  <template #default="{ row }">
                    <span style="color: red">{{ Number(row.totalAmount ?? 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="发票税额" prop="totalTaxAmount">
                  <template #default="{ row }">
                    <span style="color: red">{{ Number(row.totalTaxAmount ?? 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="冲红原因" prop="checker" :formatter="getReason" />
                <el-table-column label="状态">
                  <template #default="{ row }">
                    <span>{{ getQuerenStatus(row.isQueren) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="开具状态" prop="kaijuStatus">
                  <template #default="{ row }">
                    <span>{{ ['未开具', '已开具'][row.kaijuStatus] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                  <template #default="{ row }">
                    <el-button type="primary" link @click="checkBasic(row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="common-box">
          <h3 class="title">红字发票记录</h3>
          <div class="common-box-content">
            <div class="table_hd">
              <el-radio-group v-model="recordType" @click="selectRecord">
                <el-radio-button label="我开具的" value="fpkj" />
                <el-radio-button label="我收到的" value="fpsd" />
              </el-radio-group>
            </div>
            <div class="table_wrap">
              <el-table :data="fpList" :border="true">
                <el-table-column label="对方纳税人名称">
                  <template #default="{ row }">
                    <span>{{ row.buyer?.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="纳税人识别号">
                  <template #default="{ row }">
                    <span>{{ row.buyer?.taxRegistrationNo }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="数电票号码" prop="number" />
                <el-table-column label="对应蓝票数电票号码" prop="code" />
                <el-table-column label="发票金额" prop="totalAmount">
                  <template #default="{ row }">
                    <span style="color: red">{{ Number(row.totalAmount ?? 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="发票税额" prop="totalTaxAmount">
                  <template #default="{ row }">
                    <span style="color: red">{{ Number(row.totalTaxAmount ?? 0).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="开票日期" prop="createTime" />
                <el-table-column label="操作">
                  <template #default="{ row }">
                    <el-button type="primary" link @click="preview(row)">预览</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 红字发票查看 -->
    <hz-basic-dialog v-model="showBasic" :row="currentRow" />

    <!-- 发票预览 -->
    <invoce-dialog v-model="visible" :row="currentRow" />
  </div>
</template>

<script setup name="RedInvoice">
import { ElMessageBox, ElMessage } from 'element-plus';
import invoceDialog from '../cmp/invoceDialog.vue';
import hzBasicDialog from '../cmp/hzBasicDialog.vue';
import useInvoiceStore from '@/store/modules/invoice';
import ConfirmOuter from "../redTicketConfirm/confirmOuter.vue";
import {convertBaseData} from "@/views/digitalInvoice/redTicketConfirm/initialDataHelp.js";

const useInvoice = useInvoiceStore();

const emits = defineEmits(['changePage', 'goInvoice']);

const statistics = ref({});
const withDeal = ref(0);
const dataList = ref([]); //红字数据
const qrdList = ref([]); //发出确认单
const qrdType = ref('fcqrd'); //确认信息类型
const fpList = ref([]); //发票

const recordType = ref('fpkj');
const currentQa = inject('provideCurrentQa');

const toolList = [
  {
    name: '红字发票确认信息录入',
    text: '通过查询/选择蓝字发票来发起《红字发票信息确认单》',
    key: 'xxlr',
    url: 'https://static.rhkj.com/renhe_fe/other/redInvoice/hz1_icon.png',
  },
  {
    name: '红字发票确认信息处理',
    text: '展示所有待处理的《红字发票信息确认单》，并提供确认/拒绝/撤销操作',
    key: 'xxcl',
    url: 'https://static.rhkj.com/renhe_fe/other/redInvoice/hz2_icon.png',
  },
  {
    name: '红字发票开具',
    text: '展示所有可开票的《红字发票信息确认单》，并提供开具功能',
    key: 'fpkj',
    url: 'https://static.rhkj.com/renhe_fe/other/redInvoice/hz3_icon.png',
  },
];

const currentRow = ref({});
const visible = ref(false);
const showBasic = ref(false);

const qa39Info = computed(() => {
  if (currentQa.value.sonQueType == '39') {
    const initialData = currentQa.value.initialAnswer && JSON.parse(currentQa.value.initialAnswer) || []
    const allConfirmLength = convertBaseData(initialData).length
    const confirmedLength = (currentQa.value.solution && JSON.parse(currentQa.value.solution).userAnswer || []).length
    return  {
      allConfirmLength, // 本月收到的确认单数量
      confirmTodo: allConfirmLength - confirmedLength, // 当前待处理数量
    }
  } else {
    return {}
  }
})

onMounted(() => {
  initRed();
  initStastic();
});

function initRed() {
  const data = useInvoice.redInvoiceList;
  dataList.value = [...data];
  selectQrd(qrdType.value);
  fpList.value = [...data].filter((item) => item.kaijuStatus === 1);
  withDeal.value = [...data].filter((item) => item.isQueren === 4).length;
}

function initStastic() {
  const data = useInvoice.getRedInvoiceStatistic;
  statistics.value = Object.assign({}, data);
}

//选择确认信息
function selectQrd(val) {
  if (['fcqrd', 'fcxxb'].includes(val)) {
    qrdList.value = unref(dataList).filter((item) => item.isQueren == 1);
  } else if (val == 'fwqrd') {
    qrdList.value = unref(dataList).filter((item) => [2, 4].includes(item.isQueren));
  }
}

//选择开票记录
function selectRecord(val) {
  switch (val) {
    case 'fpkj':
      fpList.value = unref(dataList).filter((item) => item.kaijuStatus === 1);
      break;
    case 'fpsd':
      fpList.value = [];
      break;
  }
}

//常用功能
function operate(data) {
  switch (data.key) {
    case 'xxlr':
      emits('changePage', 'redInvoice_enter');
      break;
    case 'xxcl':
      emits('changePage', 'redInvoice_confirm');
      break;
    case 'fpkj':
      emits('changePage', 'redInvoice_queren');
      break;
  }
}

//获取冲红
function getQuerenStatus(cellValue) {
  let str = '';
  const mapList = [
    { label: '无需确认', value: '1' },
    { label: '购方录入待销方确认', value: '4' },
    { label: '购销双方已确认', value: '2' },
    { label: '作废', value: '6' },
    { label: '销方录入待购方确认', value: '99' },
  ];
  mapList.forEach((item) => {
    if (item.value == cellValue) {
      str = item.label;
    }
  });
  return str;
}

//获取冲红原因
function getReason(row, column, cellValue) {
  return ['', '开票有误', '服务中止', '销货退回', '销售折让'][cellValue];
}

//点击查看按钮
function checkBasic(data) {
  currentRow.value = Object.assign({}, data);
  showBasic.value = true;
}

//点击预览按钮
function preview(data) {
  currentRow.value = Object.assign({}, data);
  visible.value = true;
}

//警告功能
function warn(content) {
  let msg = content ? content : '本系统为教学系统，暂不支持此功能';
  ElMessageBox.confirm(msg, '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: #f6f7fb;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      > .bread {
        margin-inline-start: 0.1rem;
        font-weight: 600;
        color: #333;
      }
    }
  }
  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    .operate-wrap {
      width: 100%;
      .common-box {
        box-sizing: border-box;
        width: inherit;
        padding: 0 20px 20px;
        border-radius: 3px;
        background-color: #fff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
        &:not(:first-child) {
          margin-block-start: 20px;
        }
        > .title {
          width: 100%;
          height: 60px;
          line-height: 60px;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #eee;
        }
        .common-box-content {
          width: 100%;
          margin-block-start: 20px;
          .data-wrap {
            width: 100%;
            display: inline-flex;
            flex-wrap: nowrap;
            .data-item {
              flex: 1;
              position: relative;
              &::before {
                content: '';
                display: block;
                position: absolute;
                left: -20px;
                top: 0;
                bottom: 0;
                width: 1px;
                background-color: #eee;
              }
            }
          }
          .tool-box {
            width: inherit;
            > ul {
              display: inline-flex;
              gap: 20px;
              .hz-item {
                box-sizing: border-box;
                width: 360px;
                border: 1px solid #eee;
                border-radius: 4px;
                padding: 30px;
                line-height: 18px;
                cursor: pointer;
                user-select: none;
                display: flex;
                column-gap: 20px;
                justify-content: center;
                align-items: center;
              }
            }
          }
          .table_hd {
            :deep(.el-radio-group) {
              .el-radio-button {
                --el-radio-button-checked-bg-color: transparent;
                --el-radio-button-checked-text-color: var(--el-color-primary);
              }
            }
          }
          .table_wrap {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
